export default {
  array: {
    height: 120,
    gap: 10,
  },
}
